// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var SuppliersService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SuppliersService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create a new supplier
     *
     * @since 1.0.0
     *
     * @param supplier Supplier data
     * @returns Observable<any>
     */
    SuppliersService.prototype.create = function (supplier) {
        return this.apiService.apiCall('POST', 'suppliers', supplier);
    };
    /**
     * Add a employee to supplier employees
     *
     * @since 1.0.0
     * @returns Observable<any>
     */
    SuppliersService.prototype.createEmployee = function (supplierId, employee) {
        return this.apiService.apiCall('POST', "suppliers/" + supplierId + "/employees", employee);
    };
    /**
     * Add a document to supplier documents
     *
     * @since 1.0.0
     * @returns Observable<any>
     */
    SuppliersService.prototype.createDocument = function (supplierId, employee) {
        return this.apiService.apiCall('POST', "suppliers/" + supplierId + "/documents", employee);
    };
    /**
     * Get suppliers list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getList = function (start, limit, sort, sortVersus, search, register) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        if (register) {
            return this.apiService.apiCall('GET', 'suppliers/register', params);
        }
        return this.apiService.apiCall('GET', 'suppliers', params);
    };
    /**
     * Get an exportation file of all companies
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'suppliers/export', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of master's register companies only
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getRegisterExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'suppliers/export-register', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get employees list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getEmployeesList = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "suppliers/" + supplierId + "/employees", params);
    };
    /**
     * Get supplier's docs
     *
     * @since 1.0.0
     *
     * @param
     */
    SuppliersService.prototype.getDocs = function (supplierId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "document-archives/supplier-docs/" + supplierId)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given supplierId data from back-end
     *
     * @since 1.0.0
     *
     * @param supplierId ID of the supplier to get
     */
    SuppliersService.prototype.get = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "suppliers/" + supplierId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update supplier with given supplierId with given supplier data
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     * @param data New supplier's data
     */
    SuppliersService.prototype.update = function (supplierId, data) {
        return this.apiService.apiCall('PUT', "suppliers/" + supplierId, data);
    };
    /**
     * Update supplier fields with given supplierId with given supplier data
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     * @param data New supplier's data
     */
    SuppliersService.prototype.updateFields = function (supplierId, data) {
        return this.apiService.apiCall("PATCH", "suppliers/" + supplierId, data);
    };
    /**
     * Get given supplierId and employeeId data from back-end
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.updateEmployee = function (supplierId, employeeId, data) {
        var _this = this;
        return this.apiService.apiCall('PUT', "suppliers/" + supplierId + "/employees/" + employeeId, data).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given supplierId and documentId data from back-end
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.updateDocument = function (supplierId, documentId, data) {
        var _this = this;
        return this.apiService.apiCall('PUT', "suppliers/" + supplierId + "/documents/" + documentId, data).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Delete permanently a supplier
     *
     * @since 1.0.0
     *
     * @param supplierId ID of the supplier
     */
    SuppliersService.prototype.delete = function (supplierId) {
        return this.apiService.apiCall('DELETE', "suppliers/" + supplierId);
    };
    /**
     * Delete permanently a supplier's employee
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.deleteEmployee = function (supplierId, employeeId) {
        return this.apiService.apiCall('DELETE', "suppliers/" + supplierId + "/employees/" + employeeId);
    };
    /**
     * Delete permanently a supplier's employee
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.deleteDocument = function (supplierId, documentId) {
        return this.apiService.apiCall('DELETE', "suppliers/" + supplierId + "/documents/" + documentId);
    };
    /**
     * Get suppliers list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getSupplierDocumentsList = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "suppliers/" + supplierId + "/documents", params);
    };
    /**
     * Get an exportation file of all Employees of supplier
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getSupplierEmployeesExport = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "suppliers/" + supplierId + "/export-employees", {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all documents of supplier
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getSupplierDocumentsExport = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "suppliers/" + supplierId + "/export-documents", {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get enabled Master list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getEnabledMasterList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "suppliers/enabled-master", params);
    };
    /**
     * Get Master list with only Access Register for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getEnabledAccessRegisterList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "suppliers/enabled-master-access-register", params);
    };
    /**
     *  N E W
     * @version 2.0
     */
    /**
    * Create a new supplier
    *
    * @since 1.0.0
    *
    * @param supplier Supplier data
    * @returns Observable<any>
    */
    SuppliersService.prototype.createV2 = function (supplier) {
        supplier.companyName = supplier.name;
        supplier.webSite = supplier.webSiteUrl;
        return this.apiService.apiCall('POST', 'users/no-registration', supplier, {}, true, true);
    };
    /**
    * Create a new supplier
    *
    * @since 1.0.0
    *
    * @param supplier Supplier data
    * @returns Observable<any>
    */
    SuppliersService.prototype.createInvitationNfcAccess = function (supplier) {
        return this.apiService.apiCall('POST', 'users/invitation-nfc-access', supplier, {}, true, true);
    };
    /**
     * Create a new supplier by Master
     *
     * @since 1.0.0
     *
     * @param supplier Supplier data
     * @returns Observable<any>
     */
    SuppliersService.prototype.createByMaster = function (data) {
        return this.apiService.apiCall('POST', 'users/by-master', data, {}, true, true);
    };
    /**
     * Get suppliers list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     * @param [master] Only users associated to master company
     * @param [allMasters] All users associated with at least one master company
     */
    SuppliersService.prototype.getListV2 = function (start, limit, sort, sortVersus, search, master, allMasters) {
        if (!sort) {
            sort = "companyName";
            sortVersus = "asc";
        }
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        if (master) {
            return this.apiService.apiCall('GET', 'users/master-associated', params, {}, true, true);
        }
        else if (allMasters) {
            return this.apiService.apiCall('GET', 'users/all-master-associated', params, {}, true, true);
        }
        return this.apiService.apiCall('GET', 'users/performers', params, {}, true, true);
    };
    /**
     * Get suppliers list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     * @param [master] Only users associated to master company
     * @param [allMasters] All users associated with at least one master company
     */
    SuppliersService.prototype.getListVOnlyNfc = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'users/in-access-register', params, {}, true, true);
    };
    /**
     * Get given supplierId data from back-end
     *
     * @since 1.0.0
     *
     * @param supplierId ID of the supplier to get
     */
    SuppliersService.prototype.getV2 = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "users/" + supplierId, {}, {}, true, true).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Same endpoint as `getV2`, but WITHOUT reporting the error to the user.
     *
     * It exists for the callers that resolve MANY suppliers at once to turn ids into names:
     * `getV2` shows a toast per failure, so a page resolving thirty ids would bury the user
     * under thirty toasts, and a name that cannot be resolved is not something to interrupt
     * them for. The error still reaches the caller, which decides how to degrade.
     *
     * Use `getV2` for a single supplier the user explicitly asked for.
     *
     * @since 3.0.0
     *
     * @param supplierId ID of the supplier to get
     */
    SuppliersService.prototype.getV2Silent = function (supplierId) {
        return this.apiService.apiCall('GET', "users/" + supplierId, {}, {}, true, true);
    };
    /**
     * Get given supplierId extended data from back-end
     *
     * @since 1.0.0
     *
     * @param supplierId ID of the supplier to get
     */
    SuppliersService.prototype.getSupplierInfoExtended = function (supplierId) {
        return this.apiService.apiCall('GET', "creditsafe-data/user/" + supplierId, {}, {}, true, true).pipe(catchError(function (err) {
            // this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get suppliers list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getSupplierDocumentsListV2 = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "suppliers/" + supplierId + "/documentsv2", params);
    };
    /**
     * Get employees list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getEmployeesListV2 = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "users/" + supplierId + "/employees", params, {}, true, true);
    };
    /**
     * Get an exportation file of all documents of supplier
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getSupplierDocumentsExportV2 = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "suppliers/" + supplierId + "/export-documentsv2", {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all documents of supplier
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getSupplierOwnDocumentsExportV2 = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "users/" + supplierId + "/export-own-documents", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all Employees of supplier
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getSupplierEmployeesExportV2 = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "users/" + supplierId + "/export-employees", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get supplier access logs list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getAccessLogs = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'access-logs', params, {}, true, true);
    };
    /**
     * Get an exportation file of all companies
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getExportAccessLogs = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'access-logs/export', {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get supplier email sent list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getEmailSent = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "email-to-users/recipient/" + supplierId, params, {}, true, true);
    };
    /**
     * Get an exportation file of all email sent to supplier
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getSupplierEmailSentExport = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "email-to-users/recipient/" + supplierId + "/export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get supplier email sent list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getEmailSentToMaster = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "email-to-users/all-master", params, {}, true, true);
    };
    /**
     * Get an exportation file of all email sent to master
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getExportEmailSentToMaster = function () {
        var _this = this;
        return this.apiService.apiCall('GET', "email-to-users/all-master-export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get subscripiton supplier email sent list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getEmailSubscriptions = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "email-to-users/all-subscriptions", params, {}, true, true);
    };
    /**
     * Get an exportation file of all email subscription sent to supplier
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getExportEmailSubscriptions = function () {
        var _this = this;
        return this.apiService.apiCall('GET', "email-to-users/all-subscriptions-export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get documents supplier email sent list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getEmailDocuemnts = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "email-to-users/all-documents", params, {}, true, true);
    };
    /**
     * Get an exportation file of all email documents sent to supplier
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getExportEmailDocuments = function () {
        var _this = this;
        return this.apiService.apiCall('GET', "email-to-users/all-documents-export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get master associated to supplier list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getMasterAssociatedSupplier = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "users/" + supplierId + "/master-to-supplier", params, {}, true, true);
    };
    /**
      * Get an exportation file of all Employees of supplier
      *
      * @since 1.0.0
      */
    SuppliersService.prototype.getMasterAssociatedSupplierExport = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "users/" + supplierId + "/export-master-to-supplier", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get master associated to supplier list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getMasterInvitationSupplier = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "users/" + supplierId + "/master-invitation-supplier", params, {}, true, true);
    };
    /**
      * Get an exportation file of all Employees of supplier
      *
      * @since 1.0.0
      */
    SuppliersService.prototype.getMasterInvitationSupplierExport = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "users/" + supplierId + "/export-master-invitation-supplier", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Import suppliers from excel file
     *
     * @since 1.0.0
     *
     * @param suppliers Supplier data
     * @returns Observable<any>
     */
    SuppliersService.prototype.importSuppliers = function (suppliers) {
        return this.apiService.apiCall('POST', 'imports', suppliers, {}, true, true);
    };
    /**
     * Import access register suppliers from excel file
     *
     * @since 1.0.0
     *
     * @param suppliers Supplier data
     * @returns Observable<any>
     */
    SuppliersService.prototype.importAccessRegister = function (suppliers) {
        return this.apiService.apiCall('POST', 'import-access-registers', suppliers, {}, true, true);
    };
    /**
   * Import one supplier
   *
   * @since 1.0.0
   *
   * @param supplier Supplier data
   * @returns Observable<any>
   */
    SuppliersService.prototype.importSingleSuppliers = function (supplier) {
        return this.apiService.apiCall('POST', 'imports/single', supplier, {}, true, true);
    };
    /**
     * Import suppliers into cleaning from excel file
     *
     * @since 1.0.0
     *
     * @param suppliers Supplier data
     * @returns Observable<any>
     */
    SuppliersService.prototype.cleanSuppliers = function (suppliers) {
        return this.apiService.apiCall('POST', 'process-blacklists', suppliers, {}, true, true);
    };
    /**
     * Clean suppliers from excel file
     *
     * @since 1.0.0
     *
     * @param suppliers Supplier data
     * @returns Observable<any>
     */
    SuppliersService.prototype.importBlacklist = function (suppliers) {
        return this.apiService.apiCall('POST', 'blacklists', suppliers, {}, true, true);
    };
    /**
     * Send durc email to supplier
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendDurcEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-durc-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Send the DURC reminder ("sollecito") e-mail to the supplier on demand, i.e.
     * the very same e-mail the automatic cron would send, advancing the reminder
     * cycle server-side (ownDocuments[durc].notice / .sentEmail / .status).
     *
     * NOT idempotent: every successful call sends an e-mail and increments the
     * reminder counter, so the caller MUST keep the trigger disabled while the
     * request is in flight.
     * Allowed to "admin" and "operatore" roles only (403 otherwise). All the
     * preconditions checked by the front-end (DURC present, no exemption, DURC not
     * valid, PEC set) are re-validated server-side (404/409).
     * On success the response carries { docType, reminderNumber, variant, sentTo,
     * mastersNotified }: reload the supplier afterwards.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendDurcReminderEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-durc-reminder-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Notify the supplier, over PEC, that the document filed as DURC in the Albo is
     * a different document, and ask it to upload the right one.
     *
     * This is NOT a reminder: it does not consume a step of the reminder cycle, does
     * not postpone the automatic e-mail and does not touch the supplier at all
     * (notice / sentEmail / status of the DURC own-document are left untouched), so
     * the caller only needs to invalidate the sent-e-mails list, not to re-read the
     * supplier.
     * Idempotent: calling it again sends the very same e-mail, and there is no
     * server-side rate limit — the caller MUST ask for confirmation and keep the
     * trigger disabled while the request is in flight.
     * Allowed to "admin" and "operator" roles only (403 otherwise); PEC, paying
     * masters, DURC document, exemption and liquidation state are re-validated
     * server-side (404/409).
     * Unlike send-durc-email / send-pac-email the 201 is returned only when the PEC
     * really left, so the success can be trusted.
     * On success the response carries { docType, variant: 'wrongDocument', sentTo }.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendDurcNotValidEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-durc-not-valid-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Send durc email to supplier
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendVideoSecurityEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-video-security-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Send PAC email to supplier
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendPacEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-pac-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Send the PAC ("Patente a Crediti") reminder e-mail to the supplier on demand,
     * i.e. the very same e-mail the automatic cron would send, advancing the
     * reminder cycle server-side (ownDocuments[pac].notice / .sentEmail / .status).
     * Twin of sendDurcReminderEmail().
     *
     * NOT idempotent: every successful call sends an e-mail and increments the
     * reminder counter, so the caller MUST keep the trigger disabled while the
     * request is in flight.
     * Allowed to "admin" and "operatore" roles only (403 otherwise). All the
     * preconditions checked by the front-end (PAC document present, no PAC
     * exemption, supplier not declared as "non soggetto", PEC set) are re-validated
     * server-side (404/409).
     * On success the response carries { docType, reminderNumber, variant, sentTo }:
     * "variant" is "reminder" for the plain reminder (the PAC document becomes
     * notValid) or "update" when the PAC is valid and already has credits (points
     * update request, status untouched). No mastersNotified here: the PAC has no
     * escalation to the masters.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendPacReminderEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-pac-reminder-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Ask the supplier, over PEC, to update the credit points of a "Patente a
     * Crediti" already on file ("Richiesta aggiornamento punti Patente a Crediti").
     * Manual counterpart of the e-mail the automatic cycle already sends on its own.
     *
     * NOT idempotent: every successful call sends a real PEC and advances the
     * reminder counter server-side, so the caller MUST ask for confirmation, keep the
     * trigger disabled while the request is in flight and never retry automatically.
     * Allowed to "admin" and "operatore" roles only (403 otherwise). All the
     * preconditions checked by the front-end (PEC set, PAC document present WITH its
     * credits registered, no PAC exemption, supplier not declared as "non soggetto")
     * are re-validated server-side (404/409), together with the two this page cannot
     * see (at least one paying master linked, supplier not in liquidation).
     * On success the response carries { docType: 'pac', variant: 'update',
     * reminderNumber, sentTo }. The supplier changes server-side (last-send date and
     * reminder counter): the caller MUST re-read it.
     * Two error shapes need special casing by the caller, since HelperService cannot
     * render them: 401 with data.logout === true (force the logout) and 500 with
     * data.emailSent === true (the PEC really left, only its bookkeeping failed — do
     * not invite a retry, it would send a second e-mail to the supplier).
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendPacUpdateCreditsEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-pac-update-credits-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Reminder of the credit-points update request ("Richiesta aggiornamento punti
     * Patente a Crediti - Sollecito"). Twin of sendPacUpdateCreditsEmail(): same
     * request, same response shape, same preconditions and same errors, only the sent
     * text and the resulting state differ — this one also marks the credit licence as
     * expired, on top of advancing the reminder counter.
     * On success the response carries { docType: 'pac', variant: 'reminderUpdate',
     * reminderNumber, sentTo }.
     *
     * NOT idempotent, same caller duties as the twin: confirmation dialog, trigger
     * disabled while in flight, supplier re-read afterwards, no automatic retry.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendPacUpdateCreditsReminderEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-pac-update-credits-reminder-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Notify the supplier, over PEC, that the document filed as "Patente a Crediti"
     * is only the receipt, which carries no credit number and is therefore worthless,
     * and ask it to fill in the data and upload the right document.
     * Twin of sendDurcNotValidEmail(), same semantics on a different document.
     *
     * This is NOT a reminder: it does not consume a step of the reminder cycle, does
     * not postpone the automatic e-mail and does not touch the supplier at all
     * (notice / sentEmail / status / credits of the PAC own-document are left
     * untouched), so the caller only needs to invalidate the sent-e-mails list, not
     * to re-read the supplier.
     * Idempotent: calling it again sends the very same e-mail, and there is no
     * server-side rate limit — the caller MUST ask for confirmation and keep the
     * trigger disabled while the request is in flight.
     * Allowed to "admin" and "operator" roles only (403 otherwise); PEC, paying
     * masters, PAC document, exemption, notCreditLicence and liquidation state are
     * re-validated server-side (404/409). There is no "document already valid" block:
     * the filed file may be the wrong one anyway.
     * Unlike send-pac-email the 201 is returned only when the PEC really left, so the
     * success can be trusted.
     * On success the response carries { docType, variant: 'wrongDocument', sentTo }.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendPacNotValidEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-pac-not-valid-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Notify the supplier, over PEC, that the document filed as "Patente a Crediti"
     * is not a credit licence at all but a different document, and ask it to fill in
     * the data and upload the right one. The text also carries a disclaimer about any
     * personal data contained in the uploaded file (artt. 4 and 9 GDPR).
     *
     * Third of the three sibling "not valid" notifications (@see
     * sendDurcNotValidEmail, @see sendPacNotValidEmail): same request/response and
     * same semantics, only the sent text differs. The back-end shares the very same
     * implementation as send-pac-not-valid-email, so preconditions, error codes and
     * their order are guaranteed aligned; only data.variant differs
     * ('otherDocument' here, 'wrongDocument' there).
     *
     * This is NOT a reminder and does not touch the supplier at all: the caller only
     * needs to invalidate the sent-e-mails list, not to re-read the supplier.
     * Idempotent and without server-side rate limit — the caller MUST ask for
     * confirmation and keep the trigger disabled while the request is in flight.
     * Allowed to "admin" and "operator" roles only (403 otherwise).
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendPacNotValidOtherEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-pac-not-valid-other-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Send privacy email to supplier
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendPrivacyEmail = function (supplierId) {
        return this.apiService.apiCall('POST', "users/send-privacy-email/" + supplierId, {}, {}, true, true);
    };
    /**
     * Send privacy email to all active suppliers of a company
     *
     * @since 1.0.0
     *
     * @param companyId Company ID
     * @returns Observable<any>
     */
    SuppliersService.prototype.sendPrivacyEmailAll = function (companyId) {
        return this.apiService.apiCall('POST', "users/send-privacy-email-all/" + companyId, {}, {}, true, true);
    };
    /**
     * Mark the supplier's PAC (credit licence) document as "not received".
     * The back-end sets the PAC document status to "notReceived", disables
     * automatic e-mails for this supplier and notifies the linked companies.
     * The operation is idempotent.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.setPacNotReceived = function (supplierId) {
        return this.apiService.apiCall('PATCH', "users/" + supplierId + "/set-pac-not-received", {}, {}, true, true);
    };
    /**
     * Mark the supplier's DURC document as "not received".
     * Twin of setPacNotReceived(): the back-end sets every "durc" own-document to
     * status "notReceived", sets disableSendEmailDurc (suspending only the DURC
     * automatic reminders, not the PAC/SOA ones) and notifies the linked companies.
     * The operation is idempotent and has no undo endpoint.
     * A 404 is returned when the supplier has no "durc" own-document at all: its
     * localised "message" is meant to be shown to the operator as is.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ID (Mongo ObjectId)
     * @returns Observable<any>
     */
    SuppliersService.prototype.setDurcNotReceived = function (supplierId) {
        return this.apiService.apiCall('PATCH', "users/" + supplierId + "/set-durc-not-received", {}, {}, true, true);
    };
    /**
     * Get imports list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getImportList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'imports', params, {}, true, true);
    };
    /**
     * Get given importId data from back-end
     *
     * @since 1.0.0
     *
     * @param importId ID of the report to get
     */
    SuppliersService.prototype.getImport = function (importId) {
        var _this = this;
        return this.apiService.apiCall('GET', "imports/" + importId, {}, {}, true, true).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get an exportation file of all import
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getExportImportReport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'imports/export', {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get reports list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getReportList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'reports', params, {}, true, true);
    };
    /**
     * Get given reportId data from back-end
     *
     * @since 1.0.0
     *
     * @param reportId ID of the report to get
     */
    SuppliersService.prototype.getReport = function (reportId) {
        var _this = this;
        return this.apiService.apiCall('GET', "reports/" + reportId, {}, {}, true, true).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get an exportation file of all report
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getExportReport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'reports/export', {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all companies
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getExportV2 = function (type, companyId, data) {
        // if (type === "paying") { // assessment, listv2, performer, search, tank
        var _this = this;
        // }
        if (type === "tank") {
            return this.apiService.apiCall('GET', 'users/export-tank', {}, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        if (type === "listv2") {
            return this.apiService.apiCall('GET', 'users/master-associated-export', {}, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        if (type === "listv3") {
            return this.apiService.apiCall('GET', "users/master-associated-export/" + companyId, {}, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        if (type === "all") {
            return this.apiService.apiCall('GET', 'users/all-master-associated-export', {}, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        if (type === "search") {
            var params_1 = {};
            if (data) {
                Object.keys(data).forEach(function (key) {
                    var newParamKey = "search[" + key + "]";
                    var newParamValue = data[key];
                    params_1[newParamKey] = newParamValue;
                });
            }
            return this.apiService.apiCall('GET', 'users/search-all-master-associated-export', params_1, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        if (type === "searchpec") {
            var params = {};
            var newParamKey = "search[pec]";
            var newParamValue = 'void';
            params[newParamKey] = newParamValue;
            return this.apiService.apiCall('GET', 'users/all-master-associated-nopec-export', params, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        if (type === "searchDisabledEmail") {
            // const params: any = {};
            // const newParamKey = `search[disableSendEmail]`;
            // const newParamValue = true;
            // params[newParamKey] = newParamValue;
            return this.apiService.apiCall('GET', 'users/all-master-associated-disabled-email-export', {}, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        if (type === "performers") {
            return this.apiService.apiCall('GET', 'users/performers-export', {}, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        if (type === "onlyNfc") {
            return this.apiService.apiCall('GET', 'users/in-access-register-export', {}, { responseType: 'blob' }, true, true)
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        return this.apiService.apiCall('GET', 'users/export', {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get new suppliers list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getNewSuppliersInTank = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'users/new-in-tank', params, {}, true, true);
    };
    /**
     * Get employees list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getCompanyInvitationList = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "users/" + companyId + "/invitation-list", params, {}, true, true);
    };
    /**
     * Get employees list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getAdminInvitationList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "users/invitation-list-admin", params, {}, true, true);
    };
    /**
     * Get an exportation file of all companies
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getCompanyInvitationExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "users/" + companyId + "/invitation-list-export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all companies
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getAdminInvitationExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', "users/invitation-list-admin-export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get list of suppliers in blacklist for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getCleaning = function (adminId, start, limit, sort, sortVersus, search) {
        var params = { adminId: adminId, start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "process-blacklists/" + adminId, params, {}, true, true);
    };
    /**
     * Get list of suppliers in blacklist for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SuppliersService.prototype.getBlacklist = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "blacklists", params, {}, true, true);
    };
    /**
     * Get an exportation file
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getSupplierCleaningExport = function (adminId) {
        var _this = this;
        return this.apiService.apiCall('GET', "process-blacklists/" + adminId + "/export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getSupplierBlacklistExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', "blacklists/export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Set supplier into Blacklist
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.setWhitelist = function (blacklistId) {
        return this.apiService.apiCall("DELETE", "blacklists/" + blacklistId, {}, {}, true, true);
    };
    /**
     * Update imported suppliers status to Professional
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.updateImportProfessionals = function (importId, data) {
        return this.apiService.apiCall("PATCH", "imports/professionals/" + importId, data, {}, true, true);
    };
    /**
     * Set supplier into Whitelist/Blacklist
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.toggleBlacklist = function (itemId) {
        return this.apiService.apiCall("PATCH", "process-blacklists/" + itemId + "/toggle-blacklist", {}, {}, true, true);
    };
    /**
     * Update supplier in process blacklist
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.updateProcessBlacklistItem = function (itemId, data) {
        return this.apiService.apiCall("PATCH", "process-blacklists/" + itemId, data, {}, true, true);
    };
    /**
     * Empty process blacklist
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.deleteProcessBlacklist = function (adminId) {
        return this.apiService.apiCall("DELETE", "process-blacklists/" + adminId, {}, {}, true, true);
    };
    /**
     * Update supplier fields with given supplierId with given supplier data
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     * @param data New supplier's data
     */
    SuppliersService.prototype.updateFieldsV2 = function (supplierId, data) {
        return this.apiService.apiCall("PATCH", "users/" + supplierId, data, {}, true, true);
    };
    /**
     * Start process new supplier
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     */
    SuppliersService.prototype.startProcessNewSupplier = function (supplierId) {
        var data = {};
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/start-process-new", data, {}, true, true);
    };
    /**
     * Start process new supplier
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     */
    SuppliersService.prototype.endProcessNewSupplier = function (supplierId) {
        var data = {};
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/end-process-new", data, {}, true, true);
    };
    /**
     * Reject new supplier
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     */
    SuppliersService.prototype.endRejectNewSupplier = function (supplierId) {
        var data = {};
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/reject-process-new", data, {}, true, true);
    };
    /**
     * Set/Unset BiPy service to Supplier
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     * @param companyId ID of company
     */
    SuppliersService.prototype.toggleBipy = function (supplierId, companyId, companyBipyId) {
        var data = {
            companyId: companyId,
            companyBipyId: companyBipyId,
        };
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/toggle-bipy", data, {}, true, true);
    };
    /**
     * Get docs param
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.getDocsParams = function () {
        var _this = this;
        var params = { start: 0, limit: 10, sort: 'code', sortVersus: 'asc' };
        return this.apiService.apiCall('GET', 'params', params, {}, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Update supplier doc parm
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.updateParDoc = function (paramId, numberValue) {
        var data = {
            numberValue: numberValue
        };
        return this.apiService.apiCall("PATCH", "params/" + paramId, data, {}, true, true);
    };
    /**
     * Company Master: Add supplier association
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.addSupplierAssociation = function (companyId, supplierId) {
        var data = {};
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/set-company/" + companyId, data, {}, true, true);
    };
    /**
     * Set/Unset BiPy service to Supplier
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     * @param companyId ID of company
     */
    SuppliersService.prototype.setVideoSecurity = function (supplierId) {
        var data = {};
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/set-supplier-video-security", data, {}, true, true);
    };
    /**
     * Company Master: Delete supplier association
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.deleteSupplierAssociation = function (companyId, supplierId) {
        var data = {};
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/unset-company/" + companyId, data, {}, true, true);
    };
    /**
     * Company Master: Delete supplier association
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.deleteSupplierMultiAssociation = function (companiesId, supplierId) {
        var data = {
            companies: companiesId
        };
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/unset-multi-company", data, {}, true, true);
    };
    /**
     * Company Master: Delete supplier association
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.permanentlyDeleteSupplier = function (supplierId) {
        var data = {};
        return this.apiService.apiCall("DELETE", "users/" + supplierId + "/permanently", data, {}, true, true);
    };
    /**
     * Delete supplier email
     *
     * @since 1.0.0
     */
    SuppliersService.prototype.deleteSupplierEmail = function (supplierId, emailId) {
        var data = {};
        return this.apiService.apiCall("DELETE", "users/" + supplierId + "/delete-email/" + emailId, data, {}, true, true);
    };
    /**
     * Update supplier own document with given supplier data
     *
     * @since 1.0.0
     *
     * @param supplierId ID of supplier to update
     * @param data New supplier's data
     */
    SuppliersService.prototype.updateDocumentV2 = function (supplierId, data) {
        return this.apiService.apiCall("PATCH", "users/" + supplierId + "/doc", data, {}, true, true);
    };
    /**
     * Send invitation to suppliers
     *
     * @since 1.0.0
     *
     * @param data New supplier's data
     */
    SuppliersService.prototype.inviteSuppliers = function (data) {
        return this.apiService.apiCall("POST", "users/send-invitation-suppliers", data, {}, true, true);
    };
    /**
     * Send invitation to suppliers
     *
     * @since 1.0.0
     *
     * @param data New supplier's data
     */
    SuppliersService.prototype.temporaryAdminAccess = function (supplierId, data) {
        return this.apiService.apiCall("POST", "users/" + supplierId + "/admin-access", data, {}, true, true);
    };
    /**
     * Delete supplier own document with given supplier data
     *
     * @since 1.0.0
     *
     * @param supplierId
     * @param docType
     * @returns
     */
    SuppliersService.prototype.deleteSupplierOwnDocument = function (supplierId, docType) {
        return this.apiService.apiCall("DELETE", "users/" + supplierId + "/delete-own-document/" + docType, {}, {}, true, true);
    };
    // BEGIN - Supplier platform notes (suppliers back-end)
    /**
     * Get the paginated list of platform notes for a supplier.
     *
     * Suppliers back-end. Response envelope: { status, data: SupplierNote[], totalCount }.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ObjectId
     * @param [start] Pagination offset
     * @param [limit] Page size (1-100)
     * @param [sort] Sort field
     * @param [sortVersus] Sort direction ('asc' | 'desc')
     * @param [search] Column filters (e.g. { title, createdAt, createdBy })
     */
    SuppliersService.prototype.getSupplierNotes = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var value = search[key];
                if (value !== null && typeof value !== 'undefined' && value !== '') {
                    params["search[" + key + "]"] = value;
                }
            });
        }
        return this.apiService.apiCall('GET', "platform-notes/supplier/" + supplierId, params, {}, true, true);
    };
    /**
     * Get the "created by" dropdown data for a supplier's notes.
     *
     * Suppliers back-end. Response envelope: { status, data: Array<{ _id, firstName, lastName }>, totalCount }.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ObjectId
     * @param [start] Pagination offset
     * @param [limit] Page size (omit to get all creators)
     * @param [sort] Sort field
     * @param [sortVersus] Sort direction ('asc' | 'desc')
     * @param [search] Filters (e.g. { general })
     */
    SuppliersService.prototype.getSupplierNoteCreators = function (supplierId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var value = search[key];
                if (value !== null && typeof value !== 'undefined' && value !== '') {
                    params["search[" + key + "]"] = value;
                }
            });
        }
        return this.apiService.apiCall('GET', "platform-notes/supplier/" + supplierId + "/creators", params, {}, true, true);
    };
    /**
     * Create a new platform note for a supplier.
     *
     * Suppliers back-end. The server derives createdBy/supplierId from the session token,
     * so they must NOT be sent in the payload.
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ObjectId
     * @param data { title?, description?, file?: Array<{ _id }> } (file max 1 element)
     */
    SuppliersService.prototype.createSupplierNote = function (supplierId, data) {
        return this.apiService.apiCall('POST', "platform-notes/supplier/" + supplierId, data, {}, true, true);
    };
    /**
     * Partially update a supplier platform note.
     *
     * Suppliers back-end. Only the provided fields are changed.
     * file: [{ _id }] replaces the attachment, [] removes it, absent keeps it unchanged.
     *
     * @since 1.0.0
     *
     * @param noteId Note ObjectId
     * @param data Partial note data
     */
    SuppliersService.prototype.updateSupplierNote = function (noteId, data) {
        return this.apiService.apiCall('PATCH', "platform-notes/" + noteId, data, {}, true, true);
    };
    /**
     * Permanently delete a supplier platform note (hard delete).
     *
     * Suppliers back-end.
     *
     * @since 1.0.0
     *
     * @param noteId Note ObjectId
     */
    SuppliersService.prototype.deleteSupplierNote = function (noteId) {
        return this.apiService.apiCall('DELETE', "platform-notes/" + noteId, {}, {}, true, true);
    };
    /**
     * Export all notes of a supplier as an .xlsx binary file.
     *
     * Suppliers back-end. Returns a Blob (not the JSON envelope).
     *
     * @since 1.0.0
     *
     * @param supplierId Supplier ObjectId
     */
    SuppliersService.prototype.getSupplierNotesExport = function (supplierId) {
        var _this = this;
        return this.apiService.apiCall('GET', "platform-notes/supplier/" + supplierId + "/export", {}, { responseType: 'blob' }, true, true)
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get the paginated list of platform notes across ALL suppliers, with the
     * parent supplier populated on each row (companyName, vatNumber, status).
     *
     * NOTE: this endpoint does not exist yet on the suppliers back-end as of
     * writing — every other platform-notes endpoint is scoped to a single
     * supplierId (@see getSupplierNotes). This method assumes the back-end team
     * will add an unscoped `GET platform-notes` route returning the same
     * envelope as getSupplierNotes ({ status, data: SupplierNoteListItem[],
     * totalCount }), with each item's `supplier` field populated with at least
     * { _id, companyName, vatNumber, status, notRegistered }, and accepting the
     * flat field names below for both `sort` and `search[...]` (the back-end
     * maps them to the underlying populated/nested path): `companyName`,
     * `vatNumber`, `status` (supplier-side), plus `title` (the note's own
     * field). Verify/align this contract with the back-end before relying on it.
     *
     * @since 1.0.0
     *
     * @param [start] Pagination offset
     * @param [limit] Page size (1-100)
     * @param [sort] Sort field ('companyName' | 'vatNumber' | 'status' | 'title' | 'createdAt')
     * @param [sortVersus] Sort direction ('asc' | 'desc')
     * @param [search] Column filters (e.g. { companyName, vatNumber, status, title })
     */
    SuppliersService.prototype.getPlatformNotesList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var value = search[key];
                if (value !== null && typeof value !== 'undefined' && value !== '') {
                    params["search[" + key + "]"] = value;
                }
            });
        }
        return this.apiService.apiCall('GET', 'platform-notes', params, {}, true, true);
    };
    SuppliersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SuppliersService_Factory() { return new SuppliersService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: SuppliersService, providedIn: "root" });
    return SuppliersService;
}());
export { SuppliersService };
